var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.111,
    height: 11.111,
    viewBox: "0 0 11.111 11.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "time",
    d: "M53.053-905.961l1.011-.986-1.8-1.8v-2.189H50.851v2.772Zm-1.5,3.072a5.432,5.432,0,0,1-2.176-.436,5.6,5.6,0,0,1-1.759-1.184,5.6,5.6,0,0,1-1.184-1.759A5.433,5.433,0,0,1,46-908.445a5.433,5.433,0,0,1,.436-2.176,5.6,5.6,0,0,1,1.184-1.759,5.593,5.593,0,0,1,1.759-1.184A5.432,5.432,0,0,1,51.555-914a5.432,5.432,0,0,1,2.176.436,5.593,5.593,0,0,1,1.759,1.184,5.6,5.6,0,0,1,1.184,1.759,5.434,5.434,0,0,1,.436,2.176,5.433,5.433,0,0,1-.436,2.176,5.6,5.6,0,0,1-1.184,1.759,5.6,5.6,0,0,1-1.759,1.184A5.432,5.432,0,0,1,51.555-902.889ZM51.555-908.445Zm0,3.943a3.811,3.811,0,0,0,2.791-1.146,3.794,3.794,0,0,0,1.152-2.8,3.794,3.794,0,0,0-1.152-2.8,3.811,3.811,0,0,0-2.79-1.146,3.811,3.811,0,0,0-2.791,1.146,3.794,3.794,0,0,0-1.152,2.8,3.794,3.794,0,0,0,1.152,2.8A3.811,3.811,0,0,0,51.555-904.5Z",
    transform: "translate(-46 914)",
    fill: "var(--primary-color)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.061a1432009c2c6acb33b8ab4ca75a90.svg";
export { ForwardRef as ReactComponent };